import {
  DockerRBACFormData,
  DockerRBACPolicyPayload,
  AccessPolicyValue,
} from './types';

/**
 * Builds the API payload from form data
 * Returns only EnvironmentAccessPolicies (registry access handled separately)
 */
export function buildDockerRBACPayload(
  formData: DockerRBACFormData
): DockerRBACPolicyPayload {
  const accessList = formData.accessList || [];

  const initial: {
    envUserAccessPolicies: Record<string, AccessPolicyValue>;
    envTeamAccessPolicies: Record<string, AccessPolicyValue>;
  } = { envUserAccessPolicies: {}, envTeamAccessPolicies: {} };

  const { envUserAccessPolicies, envTeamAccessPolicies } = accessList.reduce(
    (acc, access) => {
      if (access.Type === 'user') {
        return {
          ...acc,
          envUserAccessPolicies: {
            ...acc.envUserAccessPolicies,
            [access.Id.toString()]: {
              RoleId: { value: access.Role.Id, enforce: false },
            },
          },
        };
      }

      if (access.Type === 'team') {
        return {
          ...acc,
          envTeamAccessPolicies: {
            ...acc.envTeamAccessPolicies,
            [access.Id.toString()]: {
              RoleId: { value: access.Role.Id, enforce: false },
            },
          },
        };
      }

      return acc;
    },
    initial
  );

  return {
    EnvironmentAccessPolicies: {
      UserAccessPolicies: envUserAccessPolicies,
      TeamAccessPolicies: envTeamAccessPolicies,
    },
  };
}
